export enum TokenMeta {
  MODEL = "token",
  PK = "id",
}
